import React, { useState, useEffect } from 'react'
import { Dropdown, Form, Input, Icon } from 'semantic-ui-react'
import { useDispatch, useSelector } from "react-redux";
import { GetAgendas } from '../../../../../graphql/agenda'
import { formatRut } from '../../../../../utils/formatter'

const baseOptions = {
  id: "add",
  key: "add",
  value: "add",
  text: "Crear Contraparte",
  label: "(+)",
};

export default function Contraparte({ name, onChange, value, income, defaultSelectedByRut, onChangeContraparteDropdown }) {
  const {
    selectedCompany: { id: companyId },
  } = useSelector((state) => state.companyList);
  const [options, setOptions] = useState([baseOptions]);
  const [search, setSearch] = useState("");
  const [contacts, setContacts] = useState([]);
  const [addContact, setAddContact] = useState({})

  const { data } = GetAgendas({
    input: { companyId },
    pagination: { limit: 30 },
    search,
  });

  useEffect(() => {
    if (options && defaultSelectedByRut) {
      const selectedOption = options.find((element) => formatRut(element.rut) === formatRut(defaultSelectedByRut))
      setAddContact({ [name]: selectedOption?.value })
      if (!selectedOption) {
        setAddContact({ [name]: "add" })
      }
    }
  }, [options])

  useEffect(() => {
    if (data) {
      const agenda = (data?.paginatedSearchAgenda?.docs || []).filter(Boolean);
      const parsed = agenda.map((m) => {
        const rut = formatRut(m?.rut);
        const nameAndRut = `${rut} ${m?.name}`;
        const label =
          m?.isClient && m?.isProvider
            ? "Cliente - Proveedor"
            : m?.isClient
              ? "Cliente"
              : "Proveedor";
        return {
          id: m?.id,
          key: m?.id,
          value: m?.id,
          text: nameAndRut,
          name: m?.name,
          rut: m?.rut,
          label,
        };
      });
      setContacts(parsed);
    }
  }, [companyId, data, search]);

  useEffect(() => {
    const providersOrClient = contacts?.filter((contact) => {
      if (
        !income &&
        (contact.label === "Proveedor" ||
          contact.label === "Cliente - Proveedor")
      ) {
        return contact;
      } else if (
        income &&
        (contact.label === "Cliente" || contact.label === "Cliente - Proveedor")
      ) {
        return contact;
      }
    });

    const newOptions = [baseOptions].concat(providersOrClient);
    setOptions(newOptions);
  }, [contacts, income]);

  return (
    <>
      {addContact?.[name] === "add" ? (
        <Form.Group widths="equal" inline>
          <Form.Field
            label="RUT"
            control={Input}
            placeholder="Ingrese Rut"
            name="contraparteRut"
            value={formatRut(value?.contraparteRut)}
            onChange={onChange}
            maxLength={12}
            className="w-100"
            required
            fluid
          />
          <Form.Field
            label="NOMBRE"
            name="contraparteName"
            control={Input}
            placeholder="Ingrese Nombre"
            value={value?.contraparteName}
            onChange={onChange}
            className="w-100 ml-2"
            required
            fluid
          />
          <div className="d-flex justify-content-center align-items-center h-100">
            <Icon
              style={{
                fontSize: "1.5em",
                marginTop: "50%",
                marginLeft: "2px",
                cursor: "pointer",
              }}
              onClick={() => setAddContact({})}
              name="remove circle"
              color="blue"
              size="big"
            />
          </div>
        </Form.Group>
      ) : <Dropdown
        selectOnBlur={false}
        className="w-100"
        label="CONTRAPARTE"
        name={name}
        value={addContact?.[name]}
        placeholder="Ingrese Contraparte"
        options={options}
        onSearchChange={(_, v) => setSearch(v.searchQuery)}
        onChange={(_, v) => {
          onChangeContraparteDropdown(_, v)
          setAddContact({ [v?.name]: v?.value })
        }}
        selection
        search
        fluid
        noResultsMessage="No se encontraron resultados."
      />}
    </>
  )
}